import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=7a99b19c&v-on-clickaway=cancel&"
import script from "./AddMenu.vue?vue&type=script&lang=ts&"
export * from "./AddMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports